import { render, staticRenderFns } from "./to-top.vue?vue&type=template&id=4f394cf0"
import script from "./to-top.vue?vue&type=script&lang=ts"
export * from "./to-top.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports